import { getAPIErrorMessage } from 'api';
import { changeIssue, commentSend, createRequest, setError, setResponseAllUserIssues, setResponseSelectedIssue, } from './store';
export const getUserIssues = () => async (dispatch, _, { api }) => {
    dispatch(createRequest());
    try {
        const response = await api.get_user_issues();
        dispatch(setResponseAllUserIssues(response));
    }
    catch (error) {
        dispatch(setError(getAPIErrorMessage(error, 'Не удалось запросить заявки')));
    }
};
export const getIssue = (ticket_id) => async (dispatch, _, { api }) => {
    dispatch(createRequest());
    try {
        const response = await api.get_issue(ticket_id);
        dispatch(setResponseSelectedIssue(response));
    }
    catch (error) {
        dispatch(setError(getAPIErrorMessage(error, 'Не удалось запросить заявку')));
    }
};
export const sendComment = (ticket_id, comment) => async (dispatch, _, { api }) => {
    dispatch(createRequest());
    try {
        await api.send_comment(ticket_id, comment);
        dispatch(commentSend());
    }
    catch (error) {
        dispatch(setError(getAPIErrorMessage(error, 'Не удалось запросить заявку')));
    }
};
export const updateIssue = (issue) => (dispatch, getState, { browser_notification_manager }) => {
    browser_notification_manager?.notify?.({
        title: `Обновление в заявке ${issue.ticket_id}`,
    });
    dispatch(changeIssue(issue));
};
